import {decode} from "jsonwebtoken";
import {UserInfo} from "../types/UserInfo";

export function getUserInfo(jwt: string | null): UserInfo | null {
  if (jwt === null) {
    return null;
  }
  const decoded = decode(jwt) as any;
  if (decoded !== null) {
    return {
      username: decoded['preferred_username'] as string,
      email: decoded['email'] as string,
      roles: decoded['roles'] as Array<string>,
      permissions: {
        canRead: true,
        canCreate: true
      }
    };
  }
  return null;
}
